




























import Vue from 'vue';
import Component from 'vue-class-component';
import About from '../../../../components/profile/About.vue';
import Languages from '../../../../components/profile/Languages.vue';
import Technologies from '../../../../components/profile/Technologies.vue';
import ScoreProgressChart from '../../../../components/profile/ScoreProgressChart.vue';
import Scores from '../../../../components/profile/Scores.vue';
import Activity from '../../../../components/profile/Activity.vue';
import WorkExperience from '../../../../components/profile/WorkExperience.vue';
import Education from '../../../../components/profile/Education.vue';
import Portfolio from '../../../../components/profile/Portfolio.vue';

@Component({
  components: {
    About,
    Languages,
    Technologies,
    ScoreProgressChart,
    Scores,
    Activity,
    WorkExperience,
    Education,
    Portfolio,
  },
})
class UserTech extends Vue {
  get hasLanguages() {
    return this.$store.state.profile.scoreBySkills && Object.keys(this.$store.state.profile.scoreBySkills).length > 0;
  }

  get hasTechnologies() {
    return (
      this.$store.state.profile.scoreByLibraries && Object.keys(this.$store.state.profile.scoreByLibraries).length > 0
    );
  }

  openSidebar() {
    this.$root.$emit('openSidebarPanel');
  }
}
export default UserTech;
